module.exports = __webpack_public_path__ + "static/media/25-10.7a17934c.mp3";